import { render } from "./telegram-stickers.vue?vue&type=template&id=3d84eb5f&scoped=true"
import script from "./telegram-stickers.vue?vue&type=script&lang=js"
export * from "./telegram-stickers.vue?vue&type=script&lang=js"

import "./telegram-stickers.vue?vue&type=style&index=0&id=3d84eb5f&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d84eb5f"]])

export default __exports__